import templateUrl from 'emun.activity/activity-quick-view.htm'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import CartItem from 'emun.cart/cart-item.model'

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
        const id = $ctrl.activity && $ctrl.activity.id || $ctrl.activityId;
        $ctrl.bus = new ServiceBus();
        $ctrl.bus.read(`QueryActivities/${id}.json?Take=1`).then(res=> {
            $ctrl.activity = Object.assign({},$ctrl.activity, res.data.results[0]);
            $ctrl.activity.items = $ctrl.activity.items.map(item => new CartItem(item));
        });
    }
}

let component = {
    bindings: {
        activityId: '@',
        activity: '<?'
    },
    controller,
    templateUrl: ($element, $attrs) =>  $attrs.templateUrl || templateUrl
}

export default component